export default __webpack_public_path__ + "static/media/PPI-patio-005.26cfa3a1.jpg";